import { createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPowerBIUrlForPage } from '../api/power-bi-api';

// eslint-disable-next-line import/prefer-default-export
export const getPowerBIUrlForPageId = createAsyncThunk(
  '/api/power-bi/getPBIUrl',
  async (args: { pageId: string; sourceId: number }) => {
    const response = await fetchPowerBIUrlForPage(args.sourceId, args.pageId);
    return { [args.pageId]: response.data.embed_url };
  }
);
